import state from '../state';
import { setupListeners } from './listeners';
import { setupKeyCollection } from './keyCollection';
import bridge from '../../../bridge';
export var initI18nspect = function (_a) {
    var i18n = _a.i18n, starling = _a.starling, languages = _a.languages, slardar = _a.slardar, tea = _a.tea, btm = _a.btm, collectSampleRatio = _a.collectSampleRatio;
    state.setAppI18n(i18n);
    state.slardar = slardar !== null && slardar !== void 0 ? slardar : null;
    state.tea = tea !== null && tea !== void 0 ? tea : null;
    state.btm = btm !== null && btm !== void 0 ? btm : null;
    setupListeners();
    setupKeyCollection({
        projects: starling.projects,
        collectSampleRatio: collectSampleRatio,
    });
    bridge.language.initInterceptor({
        starling: starling,
        languages: languages,
    });
};
